module.exports = __webpack_public_path__ + "img/seed-share.772adb64.jpg";